<template>
    <v-modal-validated title="Editar información del letrado"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       :rules="rules"
                       id="edit_lawyers_modal"
                       @closed="closeModal"
                       @accepted="editLawyer">

        <div class="user-form row">
            <div class="form-group col-6">
                <label for="name">Nombre:</label>
                <Field type="text" id="name" name="name" class="form-control" v-model="lawyer.name"/>

                <ErrorMessage name="name"/>
            </div>

            <div class="form-group col-6">
                <label for="surname">Apellidos:</label>
                <Field type="text" id="surname" name="surname" class="form-control" v-model="lawyer.surname"/>

                <ErrorMessage name="surname"/>
            </div>
        </div>

        <div class="user-form row">
            <div class="form-group col-4">
                <label for="dni">DNI:</label>
                <Field type="text" id="dni" name="dni" class="form-control" v-model="lawyer.dni"/>

                <ErrorMessage name="dni"/>
            </div>

            <div class="form-group col-4">
                <label for="collegiate_number">Número de colegiado:</label>
                <Field type="text" id="collegiate_number" name="collegiate_number" class="form-control" v-model="lawyer.collegiate_number"/>

                <ErrorMessage name="collegiate_number"/>
            </div>

            <div class="form-group col-4">
                <label for="college">Colegio:</label>
                <Field type="text" id="college" name="college" class="form-control" v-model="lawyer.college"/>

                <ErrorMessage name="college"/>
            </div>
        </div>
    </v-modal-validated>
</template>

<script>
import {editLawyer} from "../../../helpers/requests/RequestsLawyers";
import VModalValidated from "../../general/VModalValidated";
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";

export default {
    name: "LawyersListEditModal",
    components: {VModalValidated, Form, Field, ErrorMessage},
    props: {
        lawyer: {
            type: Object,
            required: true,
        }
    },
    data() {
        const rules = yup.object({
            name: yup.string().required('Debes incluir un nombre').max(50, 'Debe tener como máximo 50 caracteres'),
            surname: yup.string().required('Debes incluir como mínimo un apellido').max(50, 'Debe tener como máximo 50 caracteres'),
            dni: yup.string().nullable().max(10, 'Debe tener como máximo 10 caracteres'),
            collegiate_number: yup.string().nullable().max(50, 'Debe tener como máximo 50 caracteres'),
            college: yup.string().nullable().max(50, 'Debe tener como máximo 50 caracteres'),
        });

        return {
            rules
        }
    },
    methods: {
        async editLawyer(data) {
            try {
                data.id = this.lawyer.id;

                await editLawyer(data);

                this.$store.dispatch('app/setToastMessage', 'Cambios guardados con éxito');

                this.closeModal();
            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al guardar los cambios');

                this.closeModal();
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
